/**
 * Copy text to the clipboard (Clipboard API with execCommand fallback).
 * @returns {Promise<boolean>} true if copy succeeded
 */
export async function copyToClipboard(text) {
  if (text == null) return false;
  const value = String(text);

  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch {
    const textArea = document.createElement("textarea");
    textArea.value = value;
    textArea.style.position = "fixed";
    textArea.style.left = "-9999px";
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand("copy");
      return true;
    } catch {
      return false;
    } finally {
      document.body.removeChild(textArea);
    }
  }
}
